
import React, { Fragment } from 'react'
import {AppRow,AppLookup,AppButton,AppAction} from 'qcc'
import { Row } from 'antd';

const renderDialogDemo = (lookup?:AppLookup) =>{
    let onClose = () => {AppAction.closeDialog();} 
    return <div>默认模式（打开窗体）{lookup.state.itemState}<AppButton label='关闭' action={onClose}/></div>
}

const renderPopoverDemo = (lookup?:AppLookup) =>{
    let onClose = () => {AppAction.closePop();} 
    return <div>悬浮模式（lookupMode=1）{lookup.state.itemState}<AppButton label='关闭' action={onClose}/></div>
}

export const AppLookupDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、Lookup，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppLookup}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppLookupDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
               
                <Row style={{padding:20}}>
                    <AppRow>
                       <div style={{width:240}}>默认模式（打开窗体）：
                       </div>
                       <div style={{width:500}}>
                            <AppLookup placeholder="请选择..." lookupRender={renderDialogDemo} lookupDialogProps={{title:'AppLookupDialog'}}/>
                       </div>
                    </AppRow>
                </Row>

                <Row style={{padding:20}}>
                    <AppRow>
                       <div style={{width:240}}>悬浮模式（lookupMode=1）：
                       </div>
                       <div style={{width:500}}>
                            <AppLookup placeholder="请选择..." lookupMode={1} lookupRender={renderPopoverDemo}/>
                       </div>
                    </AppRow>
                </Row>
     
            </div>
            

    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppLookupDemo.tsx